
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useHeaderTitleSetter from "customHooks/useHeaderTitleSetter";
import StaticLayout from "layout/StaticLayout";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import { AboutLayoutProps } from "pages/about";
import { getStaticPagesLayoutData } from "ssrUtils";
const ContactUs: React.FC<AboutLayoutProps> = () => {
    const { t } = useTranslation("common");
    useHeaderTitleSetter({ title: t("contact_us"), section: "" });
    return (<div className="">
      <div>
        {contactUsData.map((item, index) => {
            const isLast = index === contactUsData.length - 1;
            return (<div className={isLast ? "px-2" : "border-bottom px-2"} key={index}>
              <div className="flex flex-row items-center px-2 my-3">
                <div className="w-1/3">
                  <span>
                    <i className={`fe-${item.icon} me-2 text-primary`}/>
                  </span>
                  <span className="text-2xl font-bold">{t(item.title)}</span>
                </div>
                <div className="w-2/3">
                  <Link href={item.url} target="_blank" className="text-blue-500">
                    {item.value}
                  </Link>
                </div>
              </div>
            </div>);
        })}
      </div>
    </div>);
};
export default ContactUs;
(ContactUs as any).Layout = StaticLayout;
const getStaticProps = getStaticPagesLayoutData;
const contactUsData = [
    {
        title: "official_email",
        icon: "mail",
        value: "info@molhamteam.com",
        url: "mailto:info@molhamteam.com"
    },
    {
        title: "germany_email",
        icon: "mail",
        value: "info.de@molhamteam.com",
        url: "mailto:info.de@molhamteam.com"
    },
    {
        title: "usa_email",
        icon: "mail",
        value: "info.usa@molhamteam.com",
        url: "mailto:info.usa@molhamteam.com"
    },
    {
        title: "sweden_email",
        icon: "mail",
        value: "info.se@molhamteam.com",
        url: "mailto:info.se@molhamteam.com"
    },
    {
        title: "canada_email",
        icon: "mail",
        value: "info.ca@molhamteam.com",
        url: "mailto:info.ca@molhamteam.com"
    },
    {
        title: "facebook_account",
        icon: "facebook",
        value: "fb.com/molhamteam",
        url: "https://www.facebook.com/molhamteam"
    },
    {
        title: "twitter_account",
        icon: "twitter",
        value: "twitter.com/molhamteam",
        url: "https://twitter.com/molhamteam"
    },
    {
        title: "instagram_account",
        icon: "instagram",
        value: "instagram.com/molhamteam",
        url: "https://www.instagram.com/molhamteam"
    },
];

    async function __Next_Translate__getStaticProps__1a13f66beeb__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/help/contact-us',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66beeb__ as getStaticProps }
  